<template>
  <div v-if="!is_success" class="form-wrap">
  
    <div class="form-fields-stack">
    
      <div class="form-field">
        <label for="first_name">First Name</label>
        <input
          type="text"
          placeholder=""
          v-model="payload.first_name"
          id="firstname"
        >
        <span>{{ errors.first_name }}</span>
      </div>

      <div class="form-field">
        <label for="last_name">Last Name</label>
        <input
          type="text"
          placeholder=""
          v-model="payload.last_name"
          id="lastname"
        >
        <span>{{ errors.last_name }}</span>
      </div>

    </div>

    <div class="form-fields-stack two-thirds">

      <div class="form-field">
        <label for="spouse">Spouse</label>
        <input
          type="text"
          placeholder=""
          v-model="payload.data.spouse"
          id="spouse"
        >
        <span>{{ errors.spouse }}</span>
      </div>

      <div class="form-field"></div>

    </div>

    <div class="form-fields-stack two-thirds-full no-labels">

      <div class="form-field">
        <label>Children</label>
        <input
          type="text"
          v-model="payload.data.children[0].name"
        >
      </div>

      <div class="form-field w-100">
        <label>Age</label>
        <input
          type="number"
          v-model="payload.data.children[0].age"
        >
      </div>

    </div>
    <div class="form-fields-stack two-thirds-full no-labels">

      <div class="form-field">
        <input
          type="text"
          v-model="payload.data.children[1].name"
        >
      </div>

      <div class="form-field w-100">
        <input
          type="number"
          v-model="payload.data.children[1].age"
        >
      </div>

    </div>
    <div class="form-fields-stack two-thirds-full no-labels">

      <div class="form-field">
        <input
          type="text"
          v-model="payload.data.children[2].name"
        >
      </div>

      <div class="form-field w-100">
        <input
          type="number"
          v-model="payload.data.children[2].age"
        >
      </div>

    </div>
    <div class="form-fields-stack two-thirds-full">

      <div class="form-field">
        <input
          type="text"
          v-model="payload.data.children[3].name"
        >
      </div>

      <div class="form-field w-100">
        <input
          type="number"
          v-model="payload.data.children[3].age"
        >
      </div>

    </div>
    
    <div class="form-fields-stack two-thirds">

      <div class="form-field">
        <label for="email">Email Address</label>
        <input
          type="text"
          placeholder=""
          v-model="payload.email"
          id="email"
        >
        <span>{{ errors.email }}</span>
      </div>

      <div class="form-field">
        <label for="phone">Phone Number</label>
        <input
          type="text"
          placeholder=""
          v-model="payload.phone"
          id="phone"
        >
        <span>{{ errors.phone }}</span>
      </div>

    </div>

    <div class="form-field">
      <label for="address">Address</label>
      <input
          type="text"
          placeholder=""
          v-model="payload.data.address"
          id="email"
      >
      <span>{{ errors.address }}</span>
    </div>

    <div class="form-field checkbox">
      <label for="updates">I would like to receive occasional update emails from St Luke’s</label>
      <div class="custom-checkbox-radio">
        <input type="checkbox" v-model="payload.data.receive_updates" value="1">
        <span></span>
      </div>
    </div>

    <div class="form-field checkbox">
      <p class="note">I would like more information in regard to the following…</p>

      <div class="check">
        <label for="updates">Introduction to St Luke’s</label>
        <div class="custom-checkbox-radio">
          <input type="checkbox" value="1" v-model="payload.data.interest.intro_to_st_lukes">
          <span></span>
        </div>
      </div>
      <div class="check">
        <label for="updates">Interest groups at St Luke’s</label>
        <div class="custom-checkbox-radio">
          <input type="checkbox" value="1" v-model="payload.data.interest.groups_at_st_lukes">
          <span></span>
        </div>
      </div>
      <div class="check">
        <label for="updates">Kid’s programmes</label>
        <div class="custom-checkbox-radio">
          <input type="checkbox" value="1" v-model="payload.data.interest.kids_programmes">
          <span></span>
        </div>
      </div>
      <div class="check">
        <label for="updates">Youth programmes</label>
        <div class="custom-checkbox-radio">
          <input type="checkbox" value="1" v-model="payload.data.interest.youth_programmes">
          <span></span>
        </div>
      </div>
      <div class="check">
        <label for="updates">Survey of St Luke’s</label>
        <div class="custom-checkbox-radio">
          <input type="checkbox" value="1" v-model="payload.data.interest.survey_of_st_lukes">
          <span></span>
        </div>
      </div>
    </div>

    <div class="form-fields-stack two-thirds">
      
      <div class="form-field">
        <label for="how_did_you_hear">How did you hear about St Luke's?</label>
        <input
            type="text"
            placeholder=""
            v-model="payload.data.how_did_you_hear"
            id="how_did_you_hear"
        >
        <span>{{ errors.how_did_you_hear }}</span>
      </div>

      <div class="form-field"></div>
    </div>

    <div class="form-field">
      <label for="message">Message</label>
      <textarea
        placeholder=""
        v-model="payload.message"
        id="message"
      ></textarea>
      <span>{{ errors.message }}</span>
    </div>

    <div class="form-field">
      <Recaptcha 
        :sitekey="sitekey" 
        submit="contactSubmit">
      </Recaptcha>
    </div>

    <div class="form-field">
      <button
        id="contactSubmit"
        class="button"
        type="submit"
        @click="submitForm()"
      >
        Submit
      </button>
    </div>

  </div>

  <div v-else>
    <div class="contact-info">
      <span>{{ success_message }}</span>
    </div>
  </div> 
</template>

<script>
import Recaptcha from './Recaptcha.vue';
export default {
	props: [
		'form_url',
    'sitekey'
	],
  components:{
    Recaptcha
  },
	data () {
    return {
      payload: {
        first_name: null,
        last_name: null,
        data: {
          address: null,
          receive_updates: false,
          how_did_you_hear: null,
          interest: {
            intro_to_st_lukes: null,
            groups_at_st_lukes: null,
            kids_programmes: null,
            youth_programmes: null,
            survey_of_st_lukes: null
          },
          spouse: null,
          children: [
          { name: null, age: null },
          { name: null, age: null },
          { name: null, age: null },
          { name: null, age: null }
        ],
        },
        email: null,
        phone: null,                        
        message: null
      },
      errors: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        message: null,
        files: null,        
        address: null,
        how_did_you_hear: null
      },
      is_success : false,
      success_message : ""
    }
  },

	mounted () {},
  
  methods: {
    clearErrors(){
      this.errors = {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        message: null,
        files: null,
        address: null,
        how_did_you_hear: null
      };
    },
		submitForm () {
			axios.post(this.form_url, this.payload)
        .then((response) => {					
          this.is_success = response.data.success
          this.success_message = response.data.message
				})
				.catch((error) => {
					if (error.response.status == 422) {
						
						$.each(error.response.data.errors, (remote_key, remote_value) => {              
							if (remote_key == 'first_name') {
								this.errors.first_name = remote_value[0]
							}
							if (remote_key == 'last_name') {
								this.errors.last_name = remote_value[0]
							}
							if (remote_key == 'email') {
								this.errors.email = remote_value[0]
							}
							if (remote_key == 'phone') {
								this.errors.phone = remote_value[0]
							}
							if (remote_key == 'message') {
								this.errors.message = remote_value[0]
							}
              if (remote_key == 'address') {
								this.errors.address = remote_value[0]
							}
              if (remote_key == 'how_did_you_hear') {
								this.errors.how_did_you_hear = remote_value[0]
							}
						});
					}
				});
      
		}
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/ConnectForm.vue